import axios from "@/axios";

const articleClassApi = {
  Tree: '/api/pad/articleClass/tree',
}

export function getArticleClass(parameter) {
  return axios({
    url: articleClassApi.Tree,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
	data: parameter,
  })
}